import { readImage } from './utils';

let cv;
class ImageProcess {
  src;
  resizeThreshold = 400;
  width;
  height;
  scale = 1;
  edge = 2;
  constructor() {
    cv = window.cv;
    if (!cv) {
      this.isError = true;
    }
  }

  revise = (src) => {
      // let backup = src.clone();
      this.src = src;
      let image = this.resize(src);
      let found = false;
      let sl = [null, new cv.Scalar(255, 255, 255, 255), new cv.Scalar(0, 0, 0, 255), new cv.Scalar(255, 0, 0, 255)];
      let dst;
      for (let i = 0, len = sl.length; i < len; i++) {
        let img = image.clone();
        if (sl[i]) img = this.getExtraEdgeImg(img, sl[i]);
        this.preprocess(img);
        let res = this.getContours(img);
        if (!res) continue;
        let points;
        if (!Array.isArray(res)) {
          if (sl[i]) res = this.putExtraEdge(res);
          // cv.imshow('outputCanvas', res);
          points = this.findPoints(res);
          console.log('isNotArray');
        } else {
          points = res;
        }
        // console.log(points);
        if (!points.length) continue;
        dst = this.warpPerspective(points);
        found = true;
        break;
      }
      console.log('end, ====')
      // cv.imshow('outputCanvas', dst);
      if (found) {
        const canvas = this.getCanvasFromMat(dst);
        return canvas;
      }

      // let img = image.clone();
      // img = this.getExtraEdgeImg(img, new cv.Scalar(255, 255, 255, 255));
      // this.preprocess(img);
      // let res = this.getContours(img);
      // if (!res) return;
      // let points;
      // if (!Array.isArray(res)) {
      //   cv.imshow('outputCanvas', res);
      //   res = this.putExtraEdge(res);
      //   points = this.findPoints(res);
      //   console.log('isNotArray');
      // } else {
      //   points = res;
      // }
      // if (!points.length) return;
      // const dst = this.warpPerspective(points);
      // cv.imshow('outputCanvas', dst);
  }

  getContours = (img) => {
    cv.Canny(img, img, 30, 120, 3);   //边缘提取

    // 筛选轮廓
    let mContours = new cv.MatVector();
    let contours = new cv.MatVector();
    let hierarchy = new cv.Mat();
    cv.findContours(img, contours, hierarchy, cv.RETR_CCOMP, cv.CHAIN_APPROX_NONE);
    let index = 0, maxArea = 0;
    // cv.imshow('outputCanvas', img);
    if (!contours.size()) return;
    const area = this.width * this.height;
    for (let i = 0; i < contours.size(); ++i) {
      let tempArea = Math.abs(cv.contourArea(contours.get(i)));
      // console.log(tempArea, area);
      if (tempArea > maxArea && tempArea > 0.1 * area && tempArea < 0.95 * area) {
        index = i;
        maxArea = tempArea;
      }
    }
    if (maxArea === 0) return;
    const foundCours = contours.get(index);
    const arcL = cv.arcLength(foundCours, true);
    let tmp = new cv.Mat();
    cv.approxPolyDP(foundCours, tmp, 0.01 * arcL, true);
    // console.log(tmp.total(), tmp);
    if (tmp.total() === 4) {
      let points = [];
      const data32S = tmp.data32S;
      for (let i = 0, len = data32S.length / 2; i < len; i++) {
        points[i] = { x: data32S[i * 2] - this.edge, y: data32S[i * 2 + 1] - this.edge };
      }
      // console.log(points);
      return points;
    }
    mContours.push_back(foundCours);
    let black = img.clone();
    black.setTo(new cv.Scalar(0));
    cv.drawContours(black, mContours, 0, new cv.Scalar(255, 0, 0), 1);
    // cv.imshow('outputCanvas', black);
    return black;
  }

  preprocess = (img) => {
    cv.cvtColor(img, img, cv.COLOR_RGB2GRAY);

    cv.GaussianBlur(img, img, new cv.Size(5, 5), 0, 0);

    let element = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(3, 3));

    cv.dilate(img, img, element);
  }

  resize = (src) => {
    const width = src.cols;
    const height = src.rows;
    const maxSize = Math.max(width, height);
    if (maxSize > this.resizeThreshold) {
      const scale = maxSize / this.resizeThreshold;
      this.scale = scale;
      this.width = Math.round(width / scale);
      this.height = Math.round(height / scale);
      const dsize = new cv.Size(this.width, this.height);
      let dst = new cv.Mat();
      cv.resize(src, dst, dsize, 0, 0, cv.INTER_AREA);
      return dst;
    }
    return src;
  }

  getExtraEdgeImg = (src, s) => {
    // let imgData = new ImageData(new Uint8ClampedArray(src.data), src.cols, this.rows);
    // const canvas = document.createElement('canvas');
    // canvas.width = this.width + 4;
    // canvas.height = this.height + 4;
    // const ctx = canvas.getContext('2d');
    // ctx.fillStyle = '#ffffff';
    // ctx.fillRect(0, 0, canvas.width, canvas.height);
    // ctx.putImageData(imgData, 2, 2);
    // const dst = cv.imread(canvas);
    let dst = new cv.Mat();
    // let s = new cv.Scalar(255, 255, 255, 255);
    const edge = this.edge;
    cv.copyMakeBorder(src, dst, edge, edge, edge, edge, cv.BORDER_CONSTANT, s);
    return dst;
  }

  putExtraEdge = (src) => {
    // const _canvas = this.getCanvasFromMat(src);
    // const ct = _canvas.getContext('2d');
    // const imgData = ct.getImageData(2, 2, this.width, this.height);
    // const canvas = document.createElement('canvas');
    // canvas.width = this.width;
    // canvas.height = this.height;
    // const ctx = canvas.getContext('2d');
    // ctx.putImageData(imgData, 0, 0);
    // const dst = cv.imread(canvas);
    let dst = new cv.Mat();
    let rect = new cv.Rect(this.edge, this.edge, this.width, this.height);
    dst = src.roi(rect);
    return dst;
  }

  findPoints = (black) => {
    let points = [];
    for (let p = 10; p < 300; p++) {
      let tempLines = new cv.Mat();
      cv.HoughLinesP(black, tempLines, 1, (Math.PI / 180), p, 30, 10);
      let lines = [];
      for (let i = 0; i < tempLines.rows; i++) {
        lines.push([tempLines.data32S[i * 4], tempLines.data32S[i * 4 + 1], tempLines.data32S[i * 4 + 2], tempLines.data32S[i * 4 + 3]]);
      }
      tempLines.delete();
      const badLineIdx = new Set();
      for (let i = 0; i < lines.length; i++) {
        for (let j = i + 1; j < lines.length; j++) {
          if (this.IsBadLine(Math.abs(lines[i][0] - lines[j][0]), Math.abs(lines[i][1] - lines[j][1])) &&
            this.IsBadLine(Math.abs(lines[i][2] - lines[j][2]), Math.abs(lines[i][3] - lines[j][3]))) {
              badLineIdx.add(j);
          }
        }
      }
      const gLine = [];
      for (let i = 0; i < lines.length; i++) {
        if (!badLineIdx.has(i)) {
          gLine.push(lines[i]);
        }
      }
      if (gLine.length !== 4) continue;
      let corners = [];
      for (let i = 0; i < 4; i++) {
        for (let j = i + 1; j < 4; j++) {
          let pt = this.computeIntersect(lines[i], lines[j]);
          // console.log(pt);
          if (pt.x < 0 && pt.x >= -50) {
            pt.x = 0;
          }
          if (pt.y < 0 && pt.y >= -50) {
            pt.y = 0;
          }
          if (pt.y > black.rows && pt.y <= black.rows + 50) {
            pt.y = black.rows;
          }
          if (pt.x > black.cols && pt.x <= black.cols + 50) {
            pt.x = black.cols;
          }
          if (pt.x >= 0 && pt.y >= 0 && pt.x <= black.cols && pt.y <= black.rows) {
            corners.push(pt);
          }
        }
      }
      if (corners.length !== 4) continue;
      // console.log(111111);
      let isGoodPoints = true;
      for (let i = 0; i < 4; i++) {
        for (let j = i + 1; j < 4; j++) {
          let distance = Math.sqrt((corners[i].x - corners[j].x)*(corners[i].x - corners[j].x) + (corners[i].y - corners[j].y)*(corners[i].y - corners[j].y));
          if (distance < 20) {
            isGoodPoints = false;
          }
        }
      }
      if (!isGoodPoints) continue;
      // console.log(corners);
      // for (let i = 0; i < 4; i++) {
      //   cv.circle(black, corners[i], 5, new cv.Scalar(255, 0, 0, 255));
      // }
      points = corners;
    // cv.imshow('outputCanvas', black);

      break;
    }
    return points;
  }

  warpPerspective = (points) => {
    let center = new cv.Point(0, 0);
    for (let i = 0; i < 4; i++) {
      center.x += points[i].x;
      center.y += points[i].y;
    }
    center.x = center.x / 4;
    center.y = center.y / 4;
    // cv.circle(black, center, 5, new cv.Scalar(255, 0, 0));
    // cv.imshow('outputCanvas', black);
    const sortPoints = this.sortCorners(points, center);
    const { width, height } = this.calcDstSize(sortPoints);

    let target = cv.Mat.zeros(height, width, cv.CV_8UC3);

    let pointMat = [];
    pointMat.push(new cv.Point(0, 0));
    pointMat.push(new cv.Point(target.cols, 0));
    pointMat.push(new cv.Point(target.cols, target.rows));
    pointMat.push(new cv.Point(0, target.rows));

    // let srcTri = cv.matFromArray(4, 1, cv.CV_32FC2, [56, 65, 368, 52, 28, 387, 389, 390]);
    // let dstTri = cv.matFromArray(4, 1, cv.CV_32FC2, [0, 0, 300, 0, 0, 300, 300, 300]);
    // let M = cv.getPerspectiveTransform(srcTri, dstTri);
    let transmtx = cv.getPerspectiveTransform(this.getVectorFormArray(sortPoints), this.getVectorFormArray(pointMat));
    cv.warpPerspective(this.src, target, transmtx, target.size());
    return target;
  }

  getCanvasFromMat = (src) => {
    let imgData = new ImageData(new Uint8ClampedArray(src.data), src.cols, src.rows);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = imgData.width;
    canvas.height = imgData.height;
    ctx.putImageData(imgData, 0, 0);
    return canvas;
  }

  IsBadLine = (a, b) => {
    return (a * a + b * b < 100);
  }

  computeIntersect = (a, b) => {
    let [x1, y1, x2, y2] = a;
    let [x3, y3, x4, y4] = b;
    let d;
    if (d = ((x1 - x2) * (y3 - y4)) - ((y1 - y2) * (x3 - x4))) {
      const pt = new window.cv.Point();
      pt.x = ((x1*y2 - y1*x2) * (x3 - x4) - (x1 - x2) * (x3*y4 - y3*x4)) / d;
      pt.y = ((x1*y2 - y1*x2) * (y3 - y4) - (y1 - y2) * (x3*y4 - y3*x4)) / d;
      return pt;
    } else {
      return new window.cv.Point(-1, -1);
    }
  }

  sortCorners = (corners, center) => {
    let top = [];
    let btm = [];
    let res = [];
    
    corners.sort((a, b) => a.x < b.x);

    for (let i = 0; i < corners.length; i++) {
      if (corners[i].y < center.y && top.length < 2) {
        top.push(corners[i]);
      } else {
        btm.push(corners[i]);
      }
    }
    if (top.length === 2 && btm.length === 2) {
      res.push(top[0].x > top[1].x ? top[1] : top[0]);
      res.push(top[0].x > top[1].x ? top[0] : top[1]);
      res.push(btm[0].x > btm[1].x ? btm[0] : btm[1]);
      res.push(btm[0].x > btm[1].x ? btm[1] : btm[0]);
    }
    return res.map(item => ({ x: item.x * this.scale, y: item.y * this.scale }));
  }

  calcDstSize = (corners) => {
    let h1 = Math.sqrt((corners[0].x - corners[3].x)*(corners[0].x - corners[3].x) + (corners[0].y - corners[3].y)*(corners[0].y - corners[3].y));
    let h2 = Math.sqrt((corners[1].x - corners[2].x)*(corners[1].x - corners[2].x) + (corners[1].y - corners[2].y)*(corners[1].y - corners[2].y));
    let w1 = Math.sqrt((corners[0].x - corners[1].x)*(corners[0].x - corners[1].x) + (corners[0].y - corners[1].y)*(corners[0].y - corners[1].y));
    let w2 = Math.sqrt((corners[2].x - corners[3].x)*(corners[2].x - corners[3].x) + (corners[2].y - corners[3].y)*(corners[2].y - corners[3].y));

    return { width: Math.max(w1, w2), height: Math.max(h1, h2) };
  }

  getVectorFormArray = (a) => {
    let arr = [];
    for (let i = 0; i < a.length; i++) {
      arr.push(a[i].x);
      arr.push(a[i].y);
    }
    let n = cv.matFromArray(4, 1, cv.CV_32FC2, arr);
    return n;
  }
}

export default ImageProcess;